import { render, staticRenderFns } from "./TraceTheSourceUpload.vue?vue&type=template&id=49a92fde&scoped=true&"
import script from "./TraceTheSourceUpload.vue?vue&type=script&lang=js&"
export * from "./TraceTheSourceUpload.vue?vue&type=script&lang=js&"
import style0 from "./TraceTheSourceUpload.vue?vue&type=style&index=0&id=49a92fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a92fde",
  null
  
)

export default component.exports